import React from "react";
import NewArrival from "../../assets/images/yourstylist/DSCF4297.jpg";
import CardSlide from "./Slider/card_slide";
import { SlideData } from "./Prodcuts";
import { motion } from "framer-motion";
const Arrival = () => {
  return (
    <>
      <div className="p-5 w-full   bg-green-40 relative">
        <motion.img
          src={NewArrival}
          alt=""
          initial={{ scale: 0.5 }}
          whileInView={{ scale: 1 }}
          transition={{
            duration: 0.5,
          }}
          className="w-full h-[300px] md:h-[300px] lg:h-[500px]  object-cover "
        />
        <div className="absolute  w-full mx-auto text-center text-black top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2">
          <h1 className="font-bold">NEW ARRIVALS</h1>
          <p className=" mb-3 md:mt-3 md:mb-8 font-semibold text-2xl md:text-4xl lg:text-5xl ">
            Black and white for spring
          </p>
          <a href={"https://yourstylistclothing.com/"}>
            <button className="p-3 px-5 bg-white rounded text-black">
              Shop Now
            </button>
          </a>
        </div>
      </div>
      <div className="mx-5 my-10">
        <h2 className="font-semibold tracking-wider text-2xl lg:text-center">
          New Arrivals
        </h2>
        <div className="flex gap-3 flex-wrap lg:justify-center my-5">
          {["Dress", "Top", "Skirt", "One-Set", "T-Shirt"].map((x) => {
            return (
              <p
                key={x}
                className={`px-5 py-2  cursor-pointer rounded-lg ${
                  x === "Dress" ? "bg-red-400 text-white" : "bg-white"
                } `}
              >
                {x}
              </p>
            );
          })}
        </div>
        <div className="lg:mx-10 mt-5">
          <CardSlide SlideData={SlideData} />
        </div>
      </div>
    </>
  );
};

export default Arrival;
